module.exports = __webpack_public_path__ + "img/type_yy.ddda40c7.png";